import {
  PriceListAddPath,
  PriceListEditPath,
  PriceListListPath,
  PriceListPath,
  PriceListPriceAddPath,
  PriceListPriceEditPath,
  PriceListPriceListPath,
  ProductAddPath,
  ProductCategoryAddPath,
  ProductCategoryEditPath,
  ProductCategoryListPath,
  ProductCategoryProductListPath,
  ProductEditPath,
  ProductListAddPath,
  ProductListEditPath,
  ProductListListPath,
  ProductListPath,
  ProductListProductAddPath,
  ProductListProductListPath,
  PromotionAddPath,
  PromotionEditPath,
  PromotionListPath,
} from '@/modules/product/paths';
import { HomePath } from '@/routing/paths';

const home = { label: 'Home', path: HomePath };

const productList = { label: 'Products', path: ProductListPath };
const productAdd = { label: 'Add', path: ProductAddPath };
const productEdit = { label: 'Edit', path: ProductEditPath.path };
const productCategoryList = { label: 'Product Categories', path: ProductCategoryListPath };
const productCategoryAdd = { label: 'Add', path: ProductCategoryAddPath };
const productCategoryEdit = { label: 'Edit', path: ProductCategoryEditPath.path };
const productCategoryProductList = { label: 'Products', path: ProductCategoryProductListPath.path };
const productListList = { label: 'Product Lists', path: ProductListListPath };
const productListAdd = { label: 'Add', path: ProductListAddPath };
const productListEdit = { label: 'Edit', path: ProductListEditPath.path };
const productListProductList = { label: 'Products', path: ProductListProductListPath.path };
const productListProductAdd = { label: 'Add', path: ProductListProductAddPath.path };
const priceListList = { label: 'Pricing', path: PriceListListPath };
const priceListAdd = { label: 'Add', path: PriceListAddPath };
const priceListEdit = { label: 'Edit', path: PriceListEditPath.path };
const priceListPriceList = { label: 'Prices', path: PriceListPriceListPath.path };
const priceListPriceAdd = { label: 'Add', path: PriceListPriceAddPath.path };
const priceListPriceEdit = { label: 'Edit', path: PriceListPriceEditPath.path };
const promotionList = { label: 'Promotions', path: PromotionListPath };
const promotionAdd = { label: 'Add', path: PromotionAddPath };
const promotionEdit = { label: 'Edit', path: PromotionEditPath.path };

const breadcrumbs = [
  {
    path: ProductListPath,
    items: [home, productList],
  },
  {
    path: ProductAddPath,
    items: [home, productList, productAdd],
  },
  {
    path: ProductEditPath.path,
    items: [home, productList, productEdit],
  },
  {
    path: ProductCategoryListPath,
    items: [home, productCategoryList],
  },
  {
    path: ProductCategoryAddPath,
    items: [home, productCategoryList, productCategoryAdd],
  },
  {
    path: ProductCategoryEditPath.path,
    items: [home, productCategoryList, productCategoryEdit],
  },
  {
    path: ProductCategoryProductListPath.path,
    items: [home, productCategoryList, productCategoryEdit, productCategoryProductList],
  },
  {
    path: ProductListListPath,
    items: [home, productListList],
  },
  {
    path: ProductListAddPath,
    items: [home, productListList, productListAdd],
  },
  {
    path: ProductListEditPath.path,
    items: [home, productListList, productListEdit],
  },
  {
    path: ProductListProductListPath.path,
    items: [home, productListList, productListEdit, productListProductList],
  },
  {
    path: ProductListProductAddPath.path,
    items: [home, productListList, productListEdit, productListProductList, productListProductAdd],
  },
  {
    path: PriceListPath,
    items: [home, priceListList],
  },
  {
    path: PriceListListPath,
    items: [home, priceListList],
  },
  {
    path: PriceListAddPath,
    items: [home, priceListList, priceListAdd],
  },
  {
    path: PriceListEditPath.path,
    items: [home, priceListList, priceListEdit],
  },
  {
    path: PriceListPriceListPath.path,
    items: [home, priceListList, priceListEdit, priceListPriceList],
  },
  {
    path: PriceListPriceAddPath.path,
    items: [home, priceListList, priceListEdit, priceListPriceList, priceListPriceAdd],
  },
  {
    path: PriceListPriceEditPath.path,
    items: [home, priceListList, priceListEdit, priceListPriceList, priceListPriceEdit],
  },
  {
    path: PromotionListPath,
    items: [home, promotionList],
  },
  {
    path: PromotionAddPath,
    items: [home, promotionList, promotionAdd],
  },
  {
    path: PromotionEditPath.path,
    items: [home, promotionList, promotionEdit],
  },
];

export default breadcrumbs;
